import { CookieStorage } from '@/lib/storage';

export const tokenStorage = new CookieStorage();
